class CommentSwiper extends HTMLElement{
    constructor() {
        super();
    }
    init(){
       
    }
    connectedCallback() {
      if(this.querySelector('.swiper-comment') && document.documentElement.clientWidth >= 750) return;
      let swiperInfo = this.querySelector(`#${this.dataset.sectionId}`) && eval("("+this.querySelector(`#${this.dataset.sectionId}`).textContent+")");
      let that = this;
      let autoplay = swiperInfo.is_autoplay ? {
        disableOnInteraction: false,
        delay: swiperInfo.autoplay_speed * 1000,
        stopOnLastSlide: false,
      } : false;
      setTimeout(()=>{
        new Swiper(`.swiper-comment`,{
          pagination: {
              el: '.swiper-comment .swiper-pagination',
          },
          loop:swiperInfo.is_loop,
          autoplay,
          
        })
      },1000)
    }
}
customElements.define('swiper-comment', CommentSwiper);
class ProductMix extends HTMLElement{
    constructor() {
        super();
        this.index = 0;
    }
    connectedCallback() {
      if(!this.dataset.swiperInfo) return;
      let thumbsSwiper = this.querySelector('.tab-werapper') ? { swiper : new Swiper(`.tab-werapper-${this.dataset.sectionId}`,{
        watchSlidesVisibility: true,
      })} : false;
      let { is_autoplay,autoplay_speed,is_loop,is_swiper_scrollbar,is_swper_button} = this.dataset.swiperInfo;
      let that = this;
      let autoplay = is_autoplay ? {
        disableOnInteraction: false,
        delay: autoplay_speed * 1000,
        stopOnLastSlide: false,
      } : false;
      let scrollbar = is_swiper_scrollbar ? {
        el: '.swiper-scrollbar',
        
      } : false;
      let spaceBetween = document.documentElement.clientWidth > 996 ? 24 : document.documentElement.clientWidth < 750 ? 12 : 18
      this.productMixSwiper = new Swiper(`.product-mix-wrapper-${this.dataset.sectionId}`,{
          observer: true,
          observeParents: true,
          observeSlideChildren: true,
          slidesPerView : 'auto',
          slidesPerGroup : 1,
          spaceBetween,
          loop:is_loop,
          autoplay,
          navigation:{
            nextEl: `.product-mix-wrapper-${this.dataset.sectionId} .swiper-button-next`,
            prevEl: `.product-mix-wrapper-${this.dataset.sectionId} .swiper-button-prev`,
          },
          scrollbar:{
            el: '.swiper-scrollbar',
            draggable: true,
          },
          
      });
      let tabWrapper = this.querySelectorAll('.tab-werapper span[data-title="false"]');
      tabWrapper.forEach((item,index)=>{
           item.addEventListener('click',(e)=>{
            this.productMixSwiper.slideTo(e.target.getAttribute('data-jump') - 1,1000,true);
            item.setAttribute('data-active','true');
            tabWrapper[this.index].setAttribute('data-active','false');
             this.index = index;
          })
      })
    }
}
customElements.define('product-mix', ProductMix);